import { handleApi } from "../../../apis";
import { POST_LOGOUT } from "../../../apis/configuration";
import {
  getLangFromAsyncStorage,
  setLangInAsyncStorage,
} from "../../../constants";
import { clearLocalStorageExcludeSomeFields } from "../../../utils";

export const authentication = (
  user,
  navigate = () => { },
  isReLogin = false,
  resetReLoginState = () => { },
) => {
  try {
    const phoneNumber = localStorage.getItem("phone_number");
    const lastVisited = localStorage.getItem("lastVisited");

    handleApi(POST_LOGOUT, null, null, navigate)
      .finally(() => {
        getLangFromAsyncStorage()
          .then((language) => {
            setLangInAsyncStorage(language);
            if (user.is_active) {
              user
                .deactivateUser()
                .then(() => {
                  clearLocalStorageExcludeSomeFields()
                  resetReLoginState();
                  navigate("/", {
                    replace: true,
                    state: { isReLogin, phoneNumber },
                  });
                })
                .catch((e) => { });
            } else {
              clearLocalStorageExcludeSomeFields()
              resetReLoginState();
              navigate("/", {
                replace: true,
                state: { isReLogin, phoneNumber },
              });
            }
            localStorage.setItem("lastVisited", lastVisited);
          })
          .catch((e) => { });
      })
      .catch((err) => { });
  } catch (e) { }
};
